export default __webpack_public_path__ + "static/media/business-04.fbfb15ea.jpg";